import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/IMG_4052.jpg";

function IntervjuJensUgland() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.interviewJensUgland.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.interviewJensUgland.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/intervju-jens-ugland"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.interviewJensUgland.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.interviewJensUgland.sections.intro")}
            {i18next.t("pages.articles.list.interviewJensUgland.sections.intro2")}
          </p>
          
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.interviewJensUgland.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
          <img
            src={article_img}
            className="w-full"
            alt={i18next.t("pages.articles.list.interviewJensUgland.imageAlt")}
          />
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.intro3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewJensUgland.sections.building.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.building.p1")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.building.p2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.building.p3")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.building.p4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewJensUgland.sections.designCode.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.designCode.p1")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.designCode.p2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.designCode.p3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewJensUgland.sections.docAccessibility.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.docAccessibility.p1")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.docAccessibility.p2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.docAccessibility.p3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewJensUgland.sections.eaa.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.eaa.p1")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.eaa.p2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.eaa.p3")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.eaa.p4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewJensUgland.sections.mission.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.mission.p1")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.mission.p2")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewJensUgland.sections.freedom.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.freedom.p1")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewJensUgland.sections.freedom.p2")}</p>

            <p className="mt-6 font-bold">
              {i18next.t("pages.articles.list.interviewJensUgland.sections.closing")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntervjuJensUgland;

